/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getCompany = /* GraphQL */ `
  query GetCompany($id: ID!) {
    getCompany(id: $id) {
      id
      name
      contact
      email
      status
      usage
      internalname
      groups
      VShits
      trackerhits
      durationhits
      alerthits
      agenthits
      sentimenthits
      topichits
      questionhits
      analyticshits
      alerts {
        nextToken
        __typename
      }
      trackers
      campaigns {
        nextToken
        __typename
      }
      agents {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listCompanies = /* GraphQL */ `
  query ListCompanies(
    $filter: ModelCompanyFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCompanies(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        contact
        email
        status
        usage
        internalname
        groups
        VShits
        trackerhits
        durationhits
        alerthits
        agenthits
        sentimenthits
        topichits
        questionhits
        analyticshits
        trackers
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getUser = /* GraphQL */ `
  query GetUser($id: ID!) {
    getUser(id: $id) {
      id
      firstname
      lastname
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const listUsers = /* GraphQL */ `
  query ListUsers(
    $filter: ModelUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUsers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        firstname
        lastname
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getAlert = /* GraphQL */ `
  query GetAlert($id: ID!) {
    getAlert(id: $id) {
      id
      name
      agent
      conversation
      campaign
      company {
        id
        name
        contact
        email
        status
        usage
        internalname
        groups
        VShits
        trackerhits
        durationhits
        alerthits
        agenthits
        sentimenthits
        topichits
        questionhits
        analyticshits
        trackers
        createdAt
        updatedAt
        __typename
      }
      groups
      createdAt
      updatedAt
      companyAlertsId
      __typename
    }
  }
`;
export const listAlerts = /* GraphQL */ `
  query ListAlerts(
    $filter: ModelAlertFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAlerts(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        agent
        conversation
        campaign
        groups
        createdAt
        updatedAt
        companyAlertsId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getAgent = /* GraphQL */ `
  query GetAgent($id: ID!) {
    getAgent(id: $id) {
      id
      name
      company {
        id
        name
        contact
        email
        status
        usage
        internalname
        groups
        VShits
        trackerhits
        durationhits
        alerthits
        agenthits
        sentimenthits
        topichits
        questionhits
        analyticshits
        trackers
        createdAt
        updatedAt
        __typename
      }
      groups
      campaigns {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      companyAgentsId
      __typename
    }
  }
`;
export const listAgents = /* GraphQL */ `
  query ListAgents(
    $filter: ModelAgentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAgents(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        groups
        createdAt
        updatedAt
        companyAgentsId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getCampaign = /* GraphQL */ `
  query GetCampaign($id: ID!) {
    getCampaign(id: $id) {
      id
      name
      startdate
      enddate
      active
      pinned
      VShits
      trackerhits
      durationhits
      alerthits
      agenthits
      sentimenthits
      topichits
      questionhits
      analyticshits
      trackers
      type
      company {
        id
        name
        contact
        email
        status
        usage
        internalname
        groups
        VShits
        trackerhits
        durationhits
        alerthits
        agenthits
        sentimenthits
        topichits
        questionhits
        analyticshits
        trackers
        createdAt
        updatedAt
        __typename
      }
      conversations {
        nextToken
        __typename
      }
      agents {
        nextToken
        __typename
      }
      groups
      createdAt
      updatedAt
      companyCampaignsId
      __typename
    }
  }
`;
export const listCampaigns = /* GraphQL */ `
  query ListCampaigns(
    $filter: ModelCampaignFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCampaigns(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        startdate
        enddate
        active
        pinned
        VShits
        trackerhits
        durationhits
        alerthits
        agenthits
        sentimenthits
        topichits
        questionhits
        analyticshits
        trackers
        type
        groups
        createdAt
        updatedAt
        companyCampaignsId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getConversation = /* GraphQL */ `
  query GetConversation($id: ID!) {
    getConversation(id: $id) {
      id
      name
      agent
      agenttag
      archive
      startdate
      sentiment
      enddate
      bookmarks
      duration
      VS
      symblstatus
      symbljobid
      symblconversationid
      alertcount
      transcript
      topics
      analytics
      questions
      summary
      trackersdetected
      file
      campaign {
        id
        name
        startdate
        enddate
        active
        pinned
        VShits
        trackerhits
        durationhits
        alerthits
        agenthits
        sentimenthits
        topichits
        questionhits
        analyticshits
        trackers
        type
        groups
        createdAt
        updatedAt
        companyCampaignsId
        __typename
      }
      groups
      createdAt
      updatedAt
      campaignConversationsId
      __typename
    }
  }
`;
export const listConversations = /* GraphQL */ `
  query ListConversations(
    $filter: ModelConversationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listConversations(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        agent
        agenttag
        archive
        startdate
        sentiment
        enddate
        bookmarks
        duration
        VS
        symblstatus
        symbljobid
        symblconversationid
        alertcount
        transcript
        topics
        analytics
        questions
        summary
        trackersdetected
        file
        groups
        createdAt
        updatedAt
        campaignConversationsId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getAgentsandcampaigns = /* GraphQL */ `
  query GetAgentsandcampaigns($id: ID!) {
    getAgentsandcampaigns(id: $id) {
      id
      agentId
      campaignId
      agent {
        id
        name
        groups
        createdAt
        updatedAt
        companyAgentsId
        __typename
      }
      campaign {
        id
        name
        startdate
        enddate
        active
        pinned
        VShits
        trackerhits
        durationhits
        alerthits
        agenthits
        sentimenthits
        topichits
        questionhits
        analyticshits
        trackers
        type
        groups
        createdAt
        updatedAt
        companyCampaignsId
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listAgentsandcampaigns = /* GraphQL */ `
  query ListAgentsandcampaigns(
    $filter: ModelAgentsandcampaignsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAgentsandcampaigns(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        agentId
        campaignId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const conversationBySConversationId = /* GraphQL */ `
  query ConversationBySConversationId(
    $symbljobid: String!
    $sortDirection: ModelSortDirection
    $filter: ModelConversationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    conversationBySConversationId(
      symbljobid: $symbljobid
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        agent
        agenttag
        archive
        startdate
        sentiment
        enddate
        bookmarks
        duration
        VS
        symblstatus
        symbljobid
        symblconversationid
        alertcount
        transcript
        topics
        analytics
        questions
        summary
        trackersdetected
        file
        groups
        createdAt
        updatedAt
        campaignConversationsId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const agentsandcampaignsByAgentId = /* GraphQL */ `
  query AgentsandcampaignsByAgentId(
    $agentId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelAgentsandcampaignsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    agentsandcampaignsByAgentId(
      agentId: $agentId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        agentId
        campaignId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const agentsandcampaignsByCampaignId = /* GraphQL */ `
  query AgentsandcampaignsByCampaignId(
    $campaignId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelAgentsandcampaignsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    agentsandcampaignsByCampaignId(
      campaignId: $campaignId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        agentId
        campaignId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
